export default {
	props: {
		maxPage: Number,
		isInfinite: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			page: 0
		};
	},
	computed: {
		isFirstPage() {
			return this.page === 0;
		},
		isLastPage() {
			return this.page + 1 === this.maxPage;
		}
	},

	methods: {
		goToPrevPage() {
			if (!this.isInfinite && this.isFirstPage)
				return;

			this.page = (this.page + this.maxPage - 1) % this.maxPage;
			this.$emit('change', this.page);
		},
		goToNextPage() {
			if (!this.isInfinite && this.isLastPage)
				return;

			this.page = (this.page + 1) % this.maxPage;
			this.$emit('change', this.page);
		}
	}
}
